import {Component, Input, OnInit} from '@angular/core';
import {ActionType} from "../../../common/enums/enums";

const ACTION_ICON_ASSET_PATH = `assets/images/issue-actions/`;

/**
 * @Todo: extract to CommonAngular.
 * Since these icons were migrated over from the Building Manager
 * they are commmonto both projects and should be pulled up
 * into the CommonAngular package.
 */
@Component({
  selector: 'app-action-icon',
  templateUrl: './action-icon.component.html',
  styleUrls: ['./action-icon.component.css']
})
export class ActionIconComponent {
  @Input()
  public icon: ActionType;
  @Input()
  public variant = ActionIconVariant.regular;

  public get iconPath(): string {
    const variantPath = this.variant === ActionIconVariant.regular ? '' : `${this.variant}/`;
    return `${ACTION_ICON_ASSET_PATH}${variantPath}${this.icon}.svg`;
  }
}

export enum ActionIconVariant {
  regular = 'regular',
  thick = 'thick',
}
